import { useEffect, useState } from 'react'
import { Button } from 'primereact/button'

import { Column, Row } from '../common/pure/FlexContainer'
import DialogContainer, { DialogContainerProps } from '../common/pure/DialogContainer'
import { TextareaField } from '../common/pure/input-fields'
import t from '../../tools/t'

interface MeasurementCommentDialogProps extends DialogContainerProps {
    initialComment?: string
    onSubmit: (comment: string) => void
}

export default function MeasurementCommentDialog({
    initialComment,
    visible,
    onHide,
    onSubmit,
    ...props
}: MeasurementCommentDialogProps) {
    const [comment, setComment] = useState(initialComment ?? '')

    useEffect(() => {
        if (!visible) return
        setComment(initialComment ?? '')
    }, [initialComment, visible])

    const submit = async () => {
        if (!comment) return
        onSubmit(comment)
        onHide()
    }

    return (
        <DialogContainer
            {...props}
            className="measurement-comment-dialog"
            visible={visible}
            header={t('common_comment')}
            size="medium"
            onHide={onHide}
        >
            <Column gap={1} className="measurement-comment-dialog__input">
                <TextareaField
                    autoResize={false}
                    approxRows={8}
                    placeholder={t('common_comment')}
                    value={comment}
                    onChange={(event) => setComment(event.target.value)}
                />
                <Row alignment="center" arrangement="spaced" gap={0.5}>
                    <Button onClick={onHide} label={t('common_cancel')} severity="secondary" text />
                    <Button onClick={submit} label={t('common_save')} disabled={!comment} />
                </Row>
            </Column>
        </DialogContainer>
    )
}
